import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container as CarrotContainer } from '@dagensmat/carrot/Layout';
import { Typography } from '@dagensmat/carrot/Components';
import PageHeader from '@components/page-header/PageHeader';
import Button, { ButtonLink } from '_common/components/button/Button.style';
import DeliveryDatePicker, {
  SelectedDeliveryDate
} from '_common/components/delivery-date-picker/DeliveryDatePicker';
import { getDagensDeliveryDates } from 'utils/delivery';
import { ReqType } from 'utils/REQ';
import { Consumer } from 'types/Consumer';
import { Page } from '@components/page';
import { BottomActions } from '@components/bottom-actions';
import { Box } from '../../../carrot/layout/box';
import { CommonNavbar } from '../../../components/navbar';

type AddOrderDeliveryDateProps = {
  selectedDeliveryDates: SelectedDeliveryDate[];
  onSelectedDeliveryDateChange: (date: SelectedDeliveryDate[]) => void;
  deliveryDates: string[];
  deliveryRoutes: any;
  producerId?: string;
  selectedConsumer: Consumer;
  // We need to fix a standardized HOC solution

  req: ReqType;
};

const AddOrderDeliveryDate = ({
  selectedDeliveryDates,
  onSelectedDeliveryDateChange,
  deliveryDates,
  deliveryRoutes,
  producerId,
  selectedConsumer
}: AddOrderDeliveryDateProps) => {
  const { t } = useTranslation();

  const dagensDeliveryDates = React.useMemo(() => {
    return getDagensDeliveryDates(deliveryRoutes, producerId);
  }, [deliveryRoutes, producerId]);

  const memoIsDagensDeliveryDate = React.useCallback(
    (slugifiedDate: string) => {
      return dagensDeliveryDates.includes(slugifiedDate);
    },
    [dagensDeliveryDates]
  );

  return (
    <Page
      header={
        <>
          <CommonNavbar />
          <Box.FullWidth>
            <PageHeader
              headerText={t('producer:SelectDeliveryDays')}
              subTitle={`${t('common:to')} ${selectedConsumer.name}`}
              annotation={`${t('common:MakeNewOrder')} (2/4)`}
            />
            <Typography my="m">
              {t('producer:selectDeliveryDaysDescription')}
            </Typography>
          </Box.FullWidth>
        </>
      }
      bottom={
        <BottomActions border>
          <ButtonLink to="/orders/add/start">
            {t('common:BackWithArrow')}
          </ButtonLink>
          {selectedDeliveryDates.length === 0 && (
            <Button disabled>{t('common:NextWithArrow')}</Button>
          )}
          {selectedDeliveryDates.length > 0 && (
            <ButtonLink
              to="/orders/add/products"
              variant="primary"
              state={{
                consumer: selectedConsumer,
                deliveryDates: selectedDeliveryDates
              }}
            >
              {t('common:NextWithArrow')}
            </ButtonLink>
          )}
        </BottomActions>
      }
    >
      <CarrotContainer mb="xl">
        <DeliveryDatePicker
          mode="multiple"
          selectedDeliveryDates={selectedDeliveryDates}
          onSelectedDeliveryDateChange={onSelectedDeliveryDateChange}
          isDagensDeliveryDate={memoIsDagensDeliveryDate}
          deliveryDates={deliveryDates}
          deliveryHubInfo=""
        />
      </CarrotContainer>
    </Page>
  );
};

export default AddOrderDeliveryDate;
